"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViolationType = exports.ActionReason = exports.ActionType = exports.NotificationStatus = exports.NotificationName = void 0;
var NotificationName;
(function (NotificationName) {
    NotificationName["ProjectExceedingTierLimit"] = "project.tier-limit-exceeded";
    // postgresql + extensions + related services (e.g. wal2json)
    NotificationName["PostgresqlUpgradeAvailable"] = "postgresql.upgrade-available";
    NotificationName["PostgresqlUpgradeCompleted"] = "postgresql.upgrade-completed";
    // non-postgresql services (e.g. realtime or gotrue)
    // ProjectUpdateAvailable = 'project.update-available',
    NotificationName["ProjectUpdateCompleted"] = "project.update-completed";
    // the freeform informational notifications are to be used sparingly, as they don't
    // really provide for e.g. i18n in any meaningful way
    // PostgresqlInformational = 'postgresql.informational',
    NotificationName["ProjectInformational"] = "project.informational";
})(NotificationName = exports.NotificationName || (exports.NotificationName = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["New"] = "new";
    NotificationStatus["Seen"] = "seen";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
var ActionType;
(function (ActionType) {
    ActionType["UpgradeProjectToPro"] = "project.upgrade";
    ActionType["SchedulePostgresRestart"] = "postgresql.restart";
    ActionType["MigratePostgresSchema"] = "postgresql.migrate";
    ActionType["PgBouncerRestart"] = "pgbouncer.restart";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ActionReason;
(function (ActionReason) {
    ActionReason["Apply"] = "apply";
    ActionReason["Rollback"] = "rollback";
    ActionReason["Finalize"] = "finalize";
})(ActionReason = exports.ActionReason || (exports.ActionReason = {}));
// ########################################
// notification type specific data objects
// ########################################
// Tier Violations
var ViolationType;
(function (ViolationType) {
    ViolationType["Storage"] = "Storage";
    ViolationType["Egress"] = "Egress";
    ViolationType["AuthUsers"] = "AuthUsers";
    ViolationType["DbSize"] = "DbSize";
})(ViolationType = exports.ViolationType || (exports.ViolationType = {}));
